import React from 'react';
import { ReactComponent as SvgLogo } from 'shared/img/logo_light_mode.svg';

export const Logo: typeof SvgLogo = (props) => {
  return <SvgLogo {...props} style={{ width: 200, height: 'auto', cursor: 'pointer', ...props.style }}/>;
};
